import clsx from 'clsx';
import { Celebrate } from '@/components/Celebrate';

interface MultipleChoiceGameProps {
  choices: Array<string>;
  correctChoice: string;
  selectedChoices: Array<string>;
  setSelectedChoices: (newChoices: Array<string>) => void;
  useGrid?: boolean;
  squareChoices?: boolean;
}

export const MultipleChoiceGame = ({
  choices,
  correctChoice,
  selectedChoices,
  setSelectedChoices,
  useGrid = true,
  squareChoices = true,
}: MultipleChoiceGameProps) => (
  <div
    className={clsx(
      useGrid ? 'grid grid-cols-3 gap-6' : 'flex gap-6 justify-center',
    )}
  >
    {choices.map((choice, index) => (
      <button
        key={index}
        role="option"
        aria-selected={selectedChoices.includes(choice)}
        aria-label={`Select ${choice}`}
        className={clsx(
          'relative h-28 p-6 text-6xl rounded-[24px] flex items-center',
          'justify-center font-sassoonInfant transition-transform duration-100',
          'shadow-[0_8px_0_rgba(0,0,0,0.15)] hover:-translate-y-0.5 active:translate-y-1',
          squareChoices && 'w-28',
          !selectedChoices.includes(choice)
            ? 'bg-white text-black'
            : choice === correctChoice
              ? 'bg-[var(--c-success)] text-white'
              : 'bg-[var(--c-select)] text-white',
        )}
        onClick={() => {
          if (selectedChoices.includes(choice)) {
            setSelectedChoices(selectedChoices.filter((l) => l !== choice));
          } else {
            setSelectedChoices([...selectedChoices, choice]);
          }
        }}
      >
        {choice}
        {selectedChoices.includes(choice) && choice === correctChoice && (
          <Celebrate className="absolute left-1/2 top-1/2" />
        )}
      </button>
    ))}
  </div>
);
